import { render, staticRenderFns } from "./DeliveryTable.vue?vue&type=template&id=61a6b64e"
import script from "./DeliveryTable.vue?vue&type=script&lang=js"
export * from "./DeliveryTable.vue?vue&type=script&lang=js"
import style0 from "./DeliveryTable.vue?vue&type=style&index=0&id=61a6b64e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports